module.exports = __webpack_public_path__ + "static/media/README.81a8bdeb.md";